import fluxUI from './ui';

var fluxComponents = {};

/**
 * Run.
 */
fluxComponents.init = function() {
    this.accountToggle();
    this.shippingToggle();
    this.orderNotesToggle();
    this.watchCountryChange();

    document.querySelector( 'html' ).classList.remove( 'no-js' );
};

/**
 * Enable the Account Toggle.
 */
fluxComponents.accountToggle = function() {
    jQuery( document ).ready( function() {
        jQuery( '.woocommerce-account-fields input#createaccount' ).unbind();
        Array.from( document.querySelectorAll( '.woocommerce-account-fields input#createaccount' ) ).forEach( function( checkbox ) {
            checkbox.addEventListener( 'change', function( e ) {
                e.preventDefault();
                e.stopPropagation();

                var accountFields = e.target.closest( '.woocommerce-account-fields' ).querySelector( 'div.create-account' );

                if ( ! accountFields ) {
                    return false;
                }

                if ( e.target.checked ) {
                    fluxUI.slideDown( accountFields );
                    accountFields.setAttribute( 'aria-hidden', 'false' );
                } else {
                    fluxUI.slideUp( accountFields );
                    accountFields.setAttribute( 'aria-hidden', 'true' );
                }

                // Remove errors.
                setTimeout( 
                    function() {
                        Array.from( accountFields.querySelectorAll( 'input, select, textarea' ) ).forEach( function( field ) {
                            field.closest( '.form-row' ).classList.remove( 'woocommerce-invalid' );
                        } );
                    }, 
                    1
                );

                jQuery( document.body ).trigger( 'country_to_state_changed' );

                return false;
            } );
        } );
    } );
};

/**
 * Enable the Shipping Toggle.
 */
fluxComponents.shippingToggle = function() {
    Array.from( document.querySelectorAll( '#ship-to-different-address input' ) ).forEach( function( checkbox ) {
        checkbox.addEventListener( 'change', function( e ) {
            e.preventDefault();
            
            var shippingAddressFields = e.target.closest( '.woocommerce-shipping-fields__wrapper' ).querySelector( '.shipping_address' );

            if ( e.target.checked ) {
                fluxUI.slideDown( shippingAddressFields );
                shippingAddressFields.setAttribute( 'aria-hidden', 'false' );
            } else {
                fluxUI.slideUp( shippingAddressFields );
                shippingAddressFields.setAttribute( 'aria-hidden', 'true' );
            }

            jQuery( document.body ).trigger( 'country_to_state_changed' );

            return false;
        } );
    } );
};

/**
 * Enable the Order Notes Toggle.
 */
fluxComponents.orderNotesToggle = function() {
    Array.from( document.querySelectorAll( '#show-additional-fields input' ) ).forEach( function( checkbox ) {
        checkbox.addEventListener( 'change', function( e ) {
            e.preventDefault();
            
            var additionalFields = e.target.closest( '.woocommerce-additional-fields__wrapper' ).querySelector( '.woocommerce-additional-fields' );

            if ( e.target.checked ) {
                fluxUI.slideDown( additionalFields );
                additionalFields.setAttribute( 'aria-hidden', 'false' );
            } else {
                fluxUI.slideUp( additionalFields );
                additionalFields.setAttribute( 'aria-hidden', 'true' );
            }

            jQuery( document.body ).trigger( 'country_to_state_changed' );

            return false;
        } );
    } );
};

/**
 * Change data-type value for the county/state field when country is changed.
 */
fluxComponents.onCountryChange = function () {
    window.setTimeout( function () {
        
        if ( jQuery( "#billing_state" ).length ) {
            var tagName = jQuery( "#billing_state" ).prop( 'tagName' );
            if ( 'SELECT' === tagName ) {
                jQuery( "#billing_state" ).closest( '.form-row' ).attr( 'data-type', 'select' );
            } else {
                jQuery( "#billing_state" ).closest( '.form-row' ).attr( 'data-type', 'text' );
                jQuery( "#billing_state" ).attr( 'placeholder', '' );
            }
        }

        if ( jQuery( "#shipping_state" ).length ) {
            var tagName = jQuery( "#shipping_state" ).prop( 'tagName' );
            if ( 'SELECT' === tagName ) {
                jQuery( "#shipping_state" ).closest( '.form-row' ).attr( 'data-type', 'select' );
            } else {
                jQuery( "#shipping_state" ).closest( '.form-row' ).attr( 'data-type', 'text' );
                jQuery( "#shipping_state" ).attr( 'placeholder', '' );
            }
        }
    } );
};

/**
 * Watch country change.
 */
fluxComponents.watchCountryChange = function () {
    if ( !jQuery( '#billing_country' ).length ) {
        fluxComponents.onCountryChange();
        return;
    }

    jQuery( '#billing_country, #shipping_country' ).change( function () {
        fluxComponents.onCountryChange();
    } );

    fluxComponents.onCountryChange();
};

export default fluxComponents;